import type { FC } from "react";

import { SearchInput } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { SearchContainer } from "./styledComponent";

interface ISearchTableTopProps {
    onChange: (value: string) => void;
}

const SearchTableTop: FC<ISearchTableTopProps> = ({ onChange }) => (
    <SearchContainer>
        <SearchInput
            debounce={300}
            onChange={onChange}
            placeholder={translate("common.search.placeholder")}
        />
    </SearchContainer>
);

export default SearchTableTop;
